import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconComputerUse: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="computer-use, cursor"><path fillRule="evenodd" clipRule="evenodd" d="M17.25 3C19.3211 3 21 4.67893 21 6.75V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V6.75C3 4.67893 4.67893 3 6.75 3H17.25ZM9.00195 7.7373C8.22025 7.4768 7.4768 8.22025 7.7373 9.00195L10.1465 16.2295C10.4596 17.1677 11.7993 17.1302 12.0596 16.1758L12.8662 13.2178C12.9128 13.047 13.047 12.9128 13.2178 12.8662L16.1758 12.0596C17.1302 11.7993 17.1677 10.4596 16.2295 10.1465L9.00195 7.7373Z" fill="currentColor"/></CentralIconBase>;
};

export default IconComputerUse;
